import {hasFeatureFlag} from '../../../shared/util/FeatureUtil';
import {CUSTOM_FIELD_TYPE_FEATURE_FLAG, CustomFieldType} from '../Constants';

// Whether the admin can pick this type when creating a custom field.
// This only hides the type here; graphql and the custom field service decide what can be created.
export const isCustomFieldTypeVisible = (type: CustomFieldType): boolean => {
	const featureFlag = CUSTOM_FIELD_TYPE_FEATURE_FLAG[type];
	return featureFlag === null || hasFeatureFlag(featureFlag);
};
